import { Application, Controller } from "@hotwired/stimulus"

export class NoEnterSubmitController extends Controller {

    preventSubmit(event) {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    }
}
